
import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";

import { BackLink } from "@/components";
import { PatientLookupForm } from "./PatientLookupForm";

import styles from "./Medical.module.scss";


export const PatientLookup: FC = () => {

  return (
    <Stack className={styles.MedicalContainer} spacing="small">
      <BackLink linkText="Home" />
      <PatientLookupForm />
    </Stack>
  );
};

export default PatientLookup;
